const faqData = [
  {
    question: "What zipcodes do you deliver to?",
    answer:
      "We currently offer delivery to the following zip codes 11416, 11414, 11418, 11419, 11421, 11208",
  },
  {
    question: "Can I order from your service anytime?",
    answer:
      "Yes, you can order from our service at any time as long as a delivery driver is available.",
  },
  {
    question: "What store does your service deliver from?",
    answer: "We deliver from Mannan supermarket located in Ozone Park.",
  },
  {
    question: "Why are the checkout price estimated?",
    answer:
      "The checkout price is estimated based on the items in your cart.The actual price of items in store might vary. The delivery driver will confirm your order receipt before arrival.",
  },
  {
    question: "How do I place an order?",
    answer:
      "Simply browse our inventory, add items to your cart, and check out.",
  },
  {
    question: "Can I cancel my order?",
    answer:
      'Yes, you can cancel your order as long as it has not been more than 10 minutes since your order was placed. Please visit the "Cancel Order" section on our website to initiate the cancellation.',
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "As of now we accept only cash on delivery payments. Feel free to pay driver in digital payments such as Zelle, Venmo on delivery. In the future we will be adding other payment options.",
  },
  {
    question: "Are you affiliated with the store?",
    answer:
      "No, we are not affiliated with the store. We are a separate entity providing the delivery service.",
  },
  {
    question: "How can I contact customer support?",
    answer:
      "You can reach our customer support team via email at grocerygo98@gmail.com.",
  },
  {
    question: "What should I do if my order is late?",
    answer:
      "If your order is delayed, please call the delivery driver that is handling your order. The delivery driver info should be sent available in the email you used to place the order.",
  },
  {
    question: "Can I cancel order if it is already in processing?",
    answer:
      "Yes, we offer cancellation of orders in processing. Please visit the 'Cancel Order' section on our website to initiate the cancellation. If you need to cancel an order and it has been more than 10 minutes since your order was placed, please reach out via email to cancel the order or call assigned driver to cancel order.",
  },
  {
    question: "Can I change my delivery address after placing an order?",
    answer:
      "No, currently we don't have that option. However feel free to call assigned delivery person to change the delivery address.",
  },
  {
    question:
      "What if there are no shoppers available? Can I still place an order?",
    answer:
      "Yes you can still place an order. However, it will be processed when there is a shopper available.",
  },
];

export default faqData;
